const steps = [
  {
    num: '1',
    text: 'Instagram ve varsa Facebook sayfanızı gönderin.',
  },
  {
    num: '2',
    text: 'İşinizi, hedef kitlenizi ve hedeflerinizi kısaca anlatın.',
  },
  {
    num: '3',
    text: 'Yaklaşık iki gün içinde size ücretsiz örnek akış hazırlansın.',
  },
  {
    num: '4',
    text: 'Örnek sistemi test edin.',
  },
  {
    num: '5',
    text: 'Uygun bulursanız ilk ay başlangıç süreci başlasın.',
  },
];

export default function FreePreviewSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100" id="on-izleme">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
              Önce Ücretsiz Örnek Sistemi Görün,
              <br />
              <span className="text-accent-600">Sonra Karar Verin.</span>
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
              Sizden ödeme almadan önce, işinize özel küçük bir örnek karşılama ve yönlendirme akışı hazırlıyoruz. Reklamdan gelen bir müşteri sizin sisteminizde nasıl karşılanacak, hangi mesajları görecek, hangi aşamalardan geçecek; bunu önceden test ediyorsunuz.
            </p>

            <div className="space-y-4 mb-8">
              {steps.map((s) => (
                <div key={s.num} className="flex items-start gap-4">
                  <div className="w-8 h-8 rounded-full bg-accent-500 flex items-center justify-center flex-shrink-0">
                    <span className="text-background-50 text-sm font-bold">{s.num}</span>
                  </div>
                  <p className="text-foreground-700 text-sm pt-1">{s.text}</p>
                </div>
              ))}
            </div>

            <div className="rounded-xl bg-accent-100/70 border border-accent-200/50 p-5">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-accent-500 flex items-center justify-center flex-shrink-0">
                  <i className="ri-information-line text-background-50"></i>
                </div>
                <p className="text-foreground-800 text-sm font-medium">
                  Siz sistemi görmeden, mantığını anlamadan ve uygun bulmadan ödeme istemiyoruz.
                </p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="rounded-2xl overflow-hidden border border-background-300/60">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20customer%20tracking%20dashboard%20interface%20with%20message%20flow%20visualization%2C%20WhatsApp%20chat%20preview%2C%20customer%20status%20cards%2C%20behavior%20analysis%20charts%2C%20clean%20dark%20navy%20and%20white%20UI%20design%2C%20electric%20blue%20accent%20elements%2C%20premium%20software%20screenshot%2C%20professional%20SaaS%20dashboard%2C%20minimal%20design%2C%20high%20detail%20data%20visualization&width=800&height=600&seq=preview-system-demo&orientation=landscape"
                alt="Ücretsiz Örnek Sistem Ön İzleme"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}